<ion-card class="ion-no-margin">
  @if (title) {
    <ion-card-header>
      <ion-card-title>{{ title }}</ion-card-title>
    </ion-card-header>
  }

  <ion-card-content>
    @if (speech) {
      <p>{{ speech }}</p>
    }
    <ion-list class="checklist">
      <ion-item>
        <ion-input
          [label]="'choixSite.searchLabel' | translate"
          labelPlacement="floating"
          fill="outline"
          type="text"
          [placeholder]="'choixSite.searchPlaceholder' | translate"
          [(ngModel)]="queryText"
          (ionInput)="onQueryChange($event.target.value)"
        >
        </ion-input>
      </ion-item>
    </ion-list>
  </ion-card-content>
</ion-card>

<div class="spinner-wrapper">
  @if (isLoading()) {
    <ion-spinner name="crescent"></ion-spinner>
  }
</div>

@for (site of sitesResult(); track site) {
  <ion-button class="result" expand="block" color="light" (click)="chooseSite(site)">
    <span class="button-text">{{ site.libelle }}</span>
    <fa-icon [icon]="faChevronRight" slot="end"></fa-icon>
  </ion-button>
}
